module.exports = __webpack_public_path__ + "static/img/satanizador-4.421eeb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/satanizador-4.jpg
// module id = E3ws
// module chunks = 1